document.addEventListener('DOMContentLoaded', () => {
	const tabsContainers = document.querySelectorAll('[data-page-tabs]');
	if (!tabsContainers.length) return;

	tabsContainers.forEach((tabs) => {
		const buttons = tabs.querySelectorAll('[data-tab-button]');
		const panels = tabs.querySelectorAll('[data-tab-panel]');

		console.log(buttons);

		tabs.addEventListener('click', (event) => {
			const button = event.target.closest('[data-tab-button]');
			if (!button) return;

			const target = button.getAttribute('data-tab-button');

			// Deactivate all buttons
			buttons.forEach((btn) => {
				btn.classList.remove('is-active');
				btn.setAttribute('aria-selected', 'false');
			});

			// Hide all panels
			panels.forEach((panel) => {
				panel.classList.remove('is-active');
				panel.hidden = true;
			});

			// Activate clicked tab and corresponding panel
			button.classList.add('is-active');
			button.setAttribute('aria-selected', 'true');

			const activePanel = tabs.querySelector(`[data-tab-panel="${target}"]`);
			if (activePanel) {
				activePanel.classList.add('is-active');
				activePanel.hidden = false;
			}
		});
	});
});
